/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var BuildingFillIcon = function BuildingFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M12.5496 2.21755C12.2161 1.99812 11.7839 1.99812 11.4504 2.21755L3.9308 7.16452C3.10158 7.71004 3.48784 8.99994 4.48041 8.99994H19.5196C20.5122 8.99994 20.8984 7.71004 20.0692 7.16452L12.5496 2.21755Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17V11H13V17H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21H4V19H20V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11V17H8V11H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17V11H18V17H16Z"
  }));
};
export default BuildingFillIcon;